export default "__VITE_ASSET__CfAHtJcB__"